'use strict';

customerZone

    .controller('AliasesController', ['$log', 'utils', 'Session', 'SubscriptionService',
        'errorCode', function($log, utils, Session, SubscriptionService, errorCode){
            var self = this;

            var init = function(){
                self.subscribers = Session.subscribers().map(function(subscriber){
                    return {
                        subscriber: subscriber,
                        product: subscriber.product,
                        msisdn: subscriber.msisdn,
                        alias: subscriber.alias,
                        newAlias: subscriber.alias
                    };
                });
            };

            self.saveAlias = function(entry){
                return SubscriptionService.updateAlias(entry.subscriber, entry.newAlias)
                    .then(function(){
                        entry.alias = entry.newAlias;
                        Session.refresh();
                    });
            };

            init();
        }]);
